import styled, { css } from "styled-components";

import { hexToRgba } from "../../../../sharable/PickerAndSelector";

export const VarejoAtacadoPromo = styled.span`
  height: min-content;
  line-height: 1.2;
  padding: 0.5px 4px;
  text-transform: uppercase;
  width: min(100%, var(--main-price-width));
  max-width: var(--main-price-width);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${({ canvasScale, styles }) => {
    const fontScale = styles.fontSize * canvasScale;
    const txtLabelBgColor = hexToRgba(styles.secondaryBgColor);
    const txtLabelTxtColor = hexToRgba(styles.secondaryTxtColor);
    return css`
      font-size: ${fontScale * 0.6}px;

      .txt {
        text-align: center;
        border-radius: ${10 * canvasScale}px;
        padding: ${canvasScale * 2}px;
        width: min(
          ${((Number(styles.fontSize) * 1.4) / 2) * 5 * canvasScale}px,
          var(--main-price-width)
        );
        font-weight: 400;
      }

      .txt.label {
        color: ${txtLabelTxtColor};
        background-color: ${txtLabelBgColor};
      }

      .txt.atc-price {
        color: ${txtLabelBgColor};
        font-weight: 700;
        background-color: ${txtLabelTxtColor};
        font-size: ${fontScale * 0.8}px;
      }
    `;
  }}
`;
